module.exports = __webpack_public_path__ + "media/images/unsplash_img_03-p-1080-e5cdb348daca53ab94c3bc6ae6c7fb91.jpeg";